<template>
  <div class="checkout-modern">
    <!-- Modern Header -->
    <header class="checkout-header" role="banner">
      <div class="header-content">
        <button class="back-btn" @click="goBack" aria-label="Go back">
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
        </button>
        <div class="header-text">
          <h1 class="checkout-title">Checkout</h1>
          <p class="checkout-subtitle">Review your order</p>
        </div>
      </div>
    </header>

    <!-- Savings Banner -->
    <div class="savings-banner" role="status" v-if="savings > 0">
      <div class="savings-content">
       
        <span>You're saving ₹{{ savings }} </span>
      </div>
    </div>

    <main class="checkout-main" role="main">
      <!-- Order Summary -->
      <section class="checkout-card" aria-labelledby="order-summary">
        <div class="card-header">
          <div class="header-icon">
            <i class="bi bi-bag-check"></i>
          </div>
          <h2 id="order-summary" class="card-title">Order Summary</h2>
        </div>
        
        <div class="course-item">
          <div class="course-image">
            <img :src="course.image || '/src/assets/img/category-1.png'" :alt="course.name || 'Course image'" loading="lazy">
          </div>
          <div class="course-details">
            <h3 class="course-name">{{ course.name }}</h3>
            <p class="course-category">{{ course?.cat_name }}</p>
            <!--<div class="course-meta">-->
            <!--  <span class="meta-item">-->
            <!--    <i class="bi bi-play-circle"></i>-->
            <!--    Digital Course-->
            <!--  </span>-->
            <!--</div>-->
          </div>
          <div class="course-price">
            <span class="final-price">₹{{ course?.cost }}</span>
          </div>
        </div>
      </section>

      <!-- Bill Breakdown -->
      <section class="checkout-card" aria-labelledby="bill-details">
        <div class="card-header">
          <div class="header-icon">
            <i class="bi bi-receipt"></i>
          </div>
          <h2 id="bill-details" class="card-title">Bill Details</h2>
        </div>
        
        <div class="bill-breakdown">
          <div class="bill-item">
            <span class="bill-label">Course Price</span>
            <span class="bill-value"><del>₹{{ course?.mrp }}</del> ₹{{ course?.cost }}</span>
          </div>
          <div class="bill-item" v-if="user_details?.balance > 0">
            <span class="bill-label">Paid</span>
            <span class="bill-value">₹{{ user_details?.paid }}</span>
          </div>
          <div class="bill-item discount" v-if="savings > 0">
            <span class="bill-label">
              <i class="bi bi-tag"></i>
              Discount Applied
            </span>
            <span class="bill-value">-₹{{ savings }}</span>
          </div>
          <div class="bill-divider"></div>



          <div class="bill-item total"  v-if="user_details?.balance > 0" >
            <span class="bill-label">Total Amount</span>
           <span class="bill-value">
              ₹{{  (user_details?.balance || 0) }}
            </span>

       
          </div>

            <div class="bill-item total"  v-else>
            <span class="bill-label">Total Amount</span>
            <span class="bill-value">₹{{ course?.cost }}</span>
       
          </div>


        </div>
      </section>





            <section class="checkout-card" aria-labelledby="payment-details">
        <div class="card-header">
          <div class="header-icon">
            <i class="bi bi-wallet2"></i>
          </div>
          <h2 id="payment-details" class="card-title">Payment Options</h2>
        </div>

        <div class="policy-content">
          <!-- Full Payment -->
          <label class="policy-item" v-if="user_details?.balance==null ">
            <input type="radio" name="payment_option" value="1" v-model="selectedOption" class="payment-radio" @click="selectInstallment('1')" />
            <div class="policy-icon">
              <i class="bi bi-cash-stack"></i>
            </div>
            <div class="policy-text">
              <h4>Full Payment</h4>
              <p>Pay the complete course fee at once and unlock all benefits immediately.</p>
            </div>
          </label>

     

         
            <h4 v-if="user_details?.balance==null">Installment</h4>

          <!-- 1st Installment -->
          <label class="policy-item"  v-if="user_details?.balance==null ">
            <input type="radio" name="payment_option" value="2" v-model="selectedOption" class="payment-radio"  @click="selectInstallment('2')"/>
            <div class="policy-icon">
              <i class="bi bi-1-circle"></i>
            </div>
            <div class="policy-text">
              <h4>1st Installment</h4>
              <p>Pay the first installment to get started with the course.</p>
            </div>
          </label>

          <!-- 2nd Installment -->
          <label class="policy-item"  v-else>
            <input type="radio" name="payment_option" value="3" v-model="selectedOption" class="payment-radio"  @click="selectInstallment('3')"/>
            <div class="policy-icon">
              <i class="bi bi-2-circle"></i>
            </div>
            <div class="policy-text">
              <h4>2nd Installment</h4>
              <p>Complete your payment by paying the second installment.</p>
            </div>
          </label>

          </div>
       
      </section>
   









      <!-- Policy Section -->
      <section class="checkout-card" aria-labelledby="policy-details">
        <div class="card-header">
          <div class="header-icon">
            <i class="bi bi-shield-check"></i>
          </div>
          <h2 id="policy-details" class="card-title">Purchase Policy</h2>
        </div>
        
        <div class="policy-content">
          <div class="policy-item">
            <div class="policy-icon">
              <i class="bi bi-clock-history"></i>
            </div>
            <div class="policy-text">
              <h4>Non-Refundable</h4>
              <p>All course purchases are final and cannot be refunded once completed.</p>
            </div>
          </div>
          <div class="policy-item">
            <div class="policy-icon">
              <i class="bi bi-infinity"></i>
            </div>
            <div class="policy-text">
              <h4>Limited Access</h4>
              <p>Get unlimited access to all course content and future updates till expiry / availability .</p>
            </div>
          </div>
        </div>
      </section>
      
      
          
            
    </main>
        
        <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="pg" aria-labelledby="pgLabel">
         <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
            <h6 class="offcanvas-title text-white m-0" id="branchLabel">Payment Process</h6>
         </div>
         <div class="offcanvas-body">
            
                    <div v-if="checkoutUrl" style="width:100%; height:600px;">
                          <iframe :src="checkoutUrl" width="100%" height="100%" frameborder="0"></iframe>
                        </div>
                 
         </div>
      </div>
    <!-- Modern Payment CTA -->
    <div class="payment-footer">
      <div class="payment-container">
        <div class="payment-summary">
          <span class="payment-label">Total</span>
          <!-- <span class="payment-amount">₹{{ course?.cost }}</span> -->
           <span class="payment-amount">₹{{ selectedAmount }}</span>

        </div>
        <button class="payment-btn" @click="enrollForCource" aria-label="Complete payment">
          <span class="btn-text">Pay Now</span>
          <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>
 
<script>
import axios from '@/plugins/axios'

export default {
  name: 'Cart',
  
  data() {
    return {
      activeFilter: 'all',
     
      lessons: [],
      user_details:[],

       course: {
          id: 0,
          name: '',
          description: '',
          image: '',
          mrp: 0,
          cost: 0,
          installment1: 0,
          installment2: 0,
          cat_name: '',
          enrolled: 'No'
        },
        paymenttype:'',
        selectedAmount:0,
        selectedOption:1,
         checkoutUrl: null,
         orderId: null,
      intervalId: null
    }
  },
  computed: {
    savings() {
      const mrp = Number(this.course?.mrp || 0)
      const cost = Number(this.course?.cost || 0)
      const diff = mrp - cost
      return diff > 0 ? diff : 0
    }
  },
   mounted() {
    window.addEventListener("message", (event) => {
      if (event.data?.status) {
        console.log("Payment Result:", event.data);
        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("pg")).hide();
        // this.$refs.phonepeIframe.remove(); // close iframe
      }
    });
  },
   beforeUnmount() {
    // Cleanup if user leaves page
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {



    async enrollForCource() {
      if (!this.course || this.course?.id == 0) return
      try {
               const response = await axios.post('enrollForCource', {
                      courceid: this.course.id,
                      paymenttype: this.paymenttype // <-- pass the selected payment type
                    });
          
        this.orderId = response.data.orderId;
        this.checkoutUrl = response.data.redirectUrl;
        if(this.checkoutUrl){
             window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("pg")).show();
               this.intervalId = setInterval(this.checkStatus, 3000);
        }
        // this.$swal?.fire(response.data.msg)
        if (response.data.status == 1) {
          this.$router.replace(`/course?id=${response.data.courceid}`)
        }
      } catch (err) {
        alert(err?.response?.data?.message || 'Something went wrong. Please try again.')
        console.log(err)
      }
    },
 async checkStatus() {
      const res = await fetch(`https://edutechapp.dktechs.in/edutech/index.php/payment/callback?id=${this.orderId}`);
      const data = await res.json();
          if (data.status !== "PENDING") {
            // Step 3: Clear iframe & stop interval
            clearInterval(this.intervalId);
            this.intervalId = null;
            this.iframeUrl = null;
            window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("pg")).hide(); 
            // this.$swal?.fire(data.message);
             this.$swal?.fire({
                title: " " + data.status,
                text: data.message || "",
                icon: data.status === "SUCCESS" ? "success" : "error",
              });
      
            if(data?.courceid){
                this.$router.push(`/course?id=${data.courceid}`);
            }
                
            // alert("Payment " + data.status);
            // console.log("Final Payment Data:", data);
          }
      },
      
      
    async selectInstallment(type){

      if(type == 1){

       
    //   this.selectedAmount = Number(this.course.cost)
       this.selectedAmount = Number(this.user_details.balance?this.user_details.balance:this.course.cost )
       this.paymenttype = 1


      }else if (type == 2){


        this.selectedAmount = Number(this.course.installment1)
      this.paymenttype = 2

      }else if(type == 3){

       this.selectedAmount = Number(this.user_details.balance?this.user_details.balance:this.course.installment2 )
             this.paymenttype = 3


        
      }

          this.realamount = this.selectedAmount




    },






    goBack() {
      this.$router.back()
    },
    async getHomeBasic(courceid = 0) {
      if (!courceid || courceid == 0) return
      try {
        const response = await axios.post('getCourceDetails', { courceid })
        if (response.data?.logged) {
          this.course = response.data.cource_details || this.course
          this.user_details=response.data.user_details;

          if(response.data.user_details){
                 this.selectedOption = response.data.user_details.paymentype_for
                 if(response.data.user_details.paymentype_for == 2){
             
                   this.selectedOption =3 ;
                   this.selectedAmount = response.data.user_details.balance;
                 }else{
                     this.selectInstallment('1');
                 } 
                 
                    this.course.cost = response.data.cource_details.cost
                    this.course.installment1 = response.data.cource_details.installment1
                    this.course.installment2 = response.data.cource_details.installment2
            
                      // this.selectedAmount = this.course.cost
            
            
                    if (response.data.user_details.paymentype_for === null) {
                        this.selectedOption = 1;
                        this.selectedAmount = response.data.cource_details.cost;
                      }

                 
         
          }

     

         


      

          this.lessons = response.data.lessons || []
        } else {
          // this.$router.push('/')
        }
      } catch (err) {
        alert(err?.response?.data?.message || 'Something went wrong. Please try again.')
        console.log(err)
      }
    }
  },
  mounted() {
    const courseId = this.$route.query.id
    this.getHomeBasic(courseId)

      this.selectInstallment('1')

  }
}
</script>

<style scoped>
.checkout-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  position: relative;
}

.checkout-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  max-width: 800px;
  margin: 0 auto;
}

.back-btn {
  background: #f8f9fa;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #495057;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.back-btn:hover {
  background: #e9ecef;
  transform: scale(1.05);
}

.checkout-title {
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

.checkout-subtitle {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
}

.savings-banner {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  padding: 0.75rem 1rem;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.savings-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.savings-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  max-width: 800px;
  margin: 0 auto;
}

.checkout-main {
  max-width: 800px;
  margin: 0 auto;
  padding: 1.5rem 1rem 8rem;
}

.checkout-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
}

.card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.course-item {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.course-image {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  background: #f8f9fa;
  flex-shrink: 0;
}

.course-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.course-details {
  flex: 1;
}

.course-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.25rem;
  line-height: 1.3;
}

.course-category {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0 0 0.5rem;
}

.course-meta {
  display: flex;
  gap: 1rem;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #495057;
  font-size: 0.85rem;
}

.meta-item i {
  color: #667eea;
}

.course-price {
  text-align: right;
}

.final-price {
  font-size: 1.5rem;
  font-weight: 700;
  color: #e74c3c;
}

.bill-breakdown {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.bill-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bill-label {
  color: #495057;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bill-value {
  font-weight: 600;
  color: #1a1a1a;
}

.bill-item.discount .bill-label {
  color: #28a745;
}

.bill-item.discount .bill-value {
  color: #28a745;
}

.bill-item.total {
  font-size: 1.1rem;
  font-weight: 700;
}

.bill-item.total .bill-label {
  color: #1a1a1a;
}

.bill-item.total .bill-value {
  color: #e74c3c;
  font-size: 1.3rem;
}

.bill-divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0.5rem 0;
}

.policy-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.policy-item {
  display: flex;
  gap: 1rem;
}

.policy-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(102, 126, 234, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.policy-text h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.25rem;
}

.policy-text p {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.5;
}

.payment-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem;
  z-index: 1000;
}

.payment-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 800px;
  margin: 0 auto;
  gap: 1rem;
}

.payment-summary {
  display: flex;
  flex-direction: column;
}

.payment-label {
  color: #6c757d;
  font-size: 0.85rem;
  font-weight: 500;
}

.payment-amount {
  color: #1a1a1a;
  font-size: 1.5rem;
  font-weight: 800;
}

.payment-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 1rem 2rem;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
  min-width: 140px;
}

.payment-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.5);
}

.payment-btn:active {
  transform: translateY(0);
}

@media (min-width: 768px) {
  .checkout-main {
    padding: 2rem 2rem 8rem;
  }
  
  .checkout-card {
    padding: 1rem;
  }
  
  .course-item {
    gap: 1.5rem;
  }
  
  .course-image {
    width: 100px;
    height: 100px;
  }
  
  .course-name {
    font-size: 1.25rem;
  }
  
  .payment-container {
    padding: 0 1rem;
  }
  
  .payment-btn {
    padding: 1.25rem 2.5rem;
    font-size: 1.1rem;
  }
}

@media (max-width: 576px) {
  .course-item {
    flex-direction: column;
    text-align: center;
  }
  
  .course-image {
    width: 120px;
    height: 120px;
    margin: 0 auto;
  }
  
  .payment-container {
    flex-direction: column;
    gap: 1rem;
  }
  
  .payment-btn {
    width: 100%;
    justify-content: center;
  }
}

.policy-item {
    display: flex;
    align-items: center;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-bottom: 12px;
    cursor: pointer;
    transition: 0.2s;
  }
  .policy-item:hover {
    background: #f9f9f9;
  }
  .payment-radio {
    margin-right: 12px;
  }










</style>